/**
 * KB-3271 — the apex (`kidsbooked.com`) custom-token endpoint URL, in its own
 * leaf module with NO behaviour and NO other imports.
 *
 * ## Why this const lives alone (landmine L379)
 *
 * This is the READ side of the apex session: `GET /api/auth/custom-token` with
 * `credentials: 'include'` answers whether the browser still holds a live apex
 * session (`{ token }` when it does, `{ token: null, reason }` when it does not).
 * Two pro-side modules need that URL — `apexSsoBootstrap.ts` (KB-3228, adopt an
 * apex session INTO pro on load) and `apexSessionChecker.ts` (KB-3271, end the
 * pro session when the apex one is gone) — so it must have a single home or the
 * two silently drift apart.
 *
 * The obvious home was `apexSsoBootstrap.ts`, and the bootstrap did declare it
 * there. But `apexSsoBootstrap` is a BEHAVIOUR module that suites `vi.mock` with
 * a partial mock and then render `AuthProvider` (e.g.
 * `AuthContext.signOut.test.tsx`). A second module reading the URL from
 * `apexSsoBootstrap` at MODULE SCOPE would pull it through that partial mock,
 * find no such export, and repeat exactly the KB-3270 collection crash recorded
 * as landmine L379 in `apexSessionEndpoint.ts` — invisible to `tsc`, to `lint`,
 * and to review, with CI Root Tests the only witness.
 *
 * So the URL lives here, dependency-free, alongside its sibling
 * `apexSessionEndpoint.ts` (the WRITE side: `/session`, mint + revoke). The two
 * endpoints are distinct resources — `/custom-token` (GET, read) vs `/session`
 * (POST/DELETE, write) — so they get distinct leaves rather than one shared
 * const. `apexSsoBootstrap.ts` re-exports `APEX_CUSTOM_TOKEN_URL` from here for
 * back-compat with existing importers. Keep this module dependency-free so it
 * stays safe to import at module scope from anywhere.
 */
export const APEX_CUSTOM_TOKEN_URL = "https://kidsbooked.com/api/auth/custom-token";
